import React from "react";
import { Arrow } from "./Arrow";
import { MaskedText, SectionLabel } from "./MaskedText";
import { TypedIdentity } from "./TypedIdentity";

export function AboutSection({ about, email }) {
  const statementLines = [
    "Useful software begins with people,",
    "then earns trust through clarity,",
    "speed, and thoughtful detail.",
  ];

  return (
    <section className="section about" id="about">
      <div className="page-width">
        <SectionLabel number="01 /">About</SectionLabel>

        <div className="about__statement" aria-label={about.statement}>
          {statementLines.map((line) => (
            <MaskedText as="p" key={line} data-scroll-mask>{line}</MaskedText>
          ))}
        </div>

        <div className="about__rule" data-line />
        <div className="about__details">
          <div className="about__intro" data-reveal="fade">
            <span>This is me.</span>
            <TypedIdentity />
            <a href={`mailto:${email}?subject=Let%27s%20build%20something`}>
              Start a conversation <Arrow />
            </a>
          </div>
          <div className="about__copy" data-reveal="fade">
            <h3>{about.title}</h3>
            {about.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          </div>
        </div>
      </div>
    </section>
  );
}
